var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveySelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6211 9.61719H12.3711C11.9611 9.61719 11.6211 9.27719 11.6211 8.86719C11.6211 8.45719 11.9611 8.11719 12.3711 8.11719H17.6211C18.0311 8.11719 18.3711 8.45719 18.3711 8.86719C18.3711 9.27719 18.0411 9.61719 17.6211 9.61719Z",
    fill: "#5B4200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11859 10.3803C6.92859 10.3803 6.73859 10.3103 6.58859 10.1603L5.83859 9.41031C5.54859 9.12031 5.54859 8.64031 5.83859 8.35031C6.12859 8.06031 6.60859 8.06031 6.89859 8.35031L7.11859 8.57031L8.83859 6.85031C9.12859 6.56031 9.60859 6.56031 9.89859 6.85031C10.1886 7.14031 10.1886 7.62031 9.89859 7.91031L7.64859 10.1603C7.50859 10.3003 7.31859 10.3803 7.11859 10.3803Z",
    fill: "#5B4200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6211 16.6172H12.3711C11.9611 16.6172 11.6211 16.2772 11.6211 15.8672C11.6211 15.4572 11.9611 15.1172 12.3711 15.1172H17.6211C18.0311 15.1172 18.3711 15.4572 18.3711 15.8672C18.3711 16.2772 18.0411 16.6172 17.6211 16.6172Z",
    fill: "#5B4200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11859 17.3803C6.92859 17.3803 6.73859 17.3103 6.58859 17.1603L5.83859 16.4103C5.54859 16.1203 5.54859 15.6403 5.83859 15.3503C6.12859 15.0603 6.60859 15.0603 6.89859 15.3503L7.11859 15.5703L8.83859 13.8503C9.12859 13.5603 9.60859 13.5603 9.89859 13.8503C10.1886 14.1403 10.1886 14.6203 9.89859 14.9103L7.64859 17.1603C7.50859 17.3003 7.31859 17.3803 7.11859 17.3803Z",
    fill: "#5B4200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#5B4200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySelect);
export default __webpack_public_path__ + "static/media/SurveySelect.f9e31ebb39de53c366b0f0b42237edd3.svg";
export { ForwardRef as ReactComponent };